import { COLORS } from "../../options/historical-charts/COLORS";

export type ChartColorValue = string

export interface StackedAreaColor {
  color: ChartColorValue
  line: ChartColorValue;
  area: ChartColorValue;
}

export interface AreaColor {
  color: ChartColorValue
  topColor: ChartColorValue
  bottomColor: ChartColorValue
}

export interface BasicColor {
  color: ChartColorValue
}

export interface ChartColors {
  single: ChartColor
  list: ChartColor[]
}

export type ChartColor = ChartColorValue | StackedAreaColor | AreaColor

const mapToBasic = (c: ChartColor) => new Object({ color: c }) as ChartColor
const mapToArea = (c: ChartColor) => new Object({ color: c, topColor: c, bottomColor: c, lineColor: c }) as AreaColor
const mapToStackedArea = (c: ChartColor) => new Object({ color:c, line: c, area: c }) as StackedAreaColor
const getSingleColor = (array: ChartColor[]): ChartColor => array[1]
const mapToHistogramColor = mapToArea

const basicColorsMapped = COLORS.map(mapToBasic)
export const BASIC_COLORS: ChartColors = {
  single: getSingleColor(basicColorsMapped),
  list: basicColorsMapped
}
const areaColorsMapped = COLORS.map(mapToArea)
export const AREA_COLORS: ChartColors = {
  single: getSingleColor(areaColorsMapped),
  list: areaColorsMapped
}

const stackedColorsMapped = COLORS.map(mapToStackedArea)
export const COLORS_STACKED: ChartColors = {
  single: getSingleColor(stackedColorsMapped),
  list: stackedColorsMapped
}

export const histogramColorsMapped = COLORS.map(mapToHistogramColor)
export const HISTOGRAM_COLORS: ChartColors = {
  single: getSingleColor(histogramColorsMapped),
  list: histogramColorsMapped
}
